import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { SortableTable } from './services-table-helper';

@Injectable({
  providedIn: 'root'
})
export class SettlementsTableService extends SortableTable<any> {
  private baseUrl = environment.API_URL;

  settlements: any[];
  settlementsLength: number;

  constructor(private http: HttpClient) {
    super();
  }

  sortEvent() {
    const tables = this.sort(this.settlements, this._state.sortColumn, this._state.sortDirection);
    this._tables$.next(tables);
  }

  getSettlementsAPI(obj) {
    return this.http.post(
      `${this.baseUrl}/locations/`,
      {
        ...obj,
      }
    ).pipe(map((response: any) => {
      this.settlements = response.result;
      this.settlementsLength = response.count;

      this.paginate();
      this.sortEvent();
      this._total$.next(this.settlementsLength);

      return response;
    }));
  }

  updateSettlement(settlement) {
    return this.http.post(
      `${this.baseUrl}/locations/update/`,
      settlement
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  /**
   * Paginate Method
   */
  private paginate(): void {
    this.totalRecords = this.settlementsLength;
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.settlementsLength) {
      this._state.endIndex = this.settlementsLength;
    }
  }

}
